import React from "react";
import Greeting from "./Greeting";

const NewUserInfo = props => {
	return (
		<>
			<Greeting user={props.user} />
			<p>Let’s get your account set up so you can login and use Dartmouth’s online services.</p>
			<p>
				Get familiar with your NetID, which will be used when logging in. You can think of it like a username to your
				Dartmouth account.
			</p>
			<p>For example, you’ll need your NetID to access your Dartmouth email.</p>
		</>
	);
};

export default NewUserInfo;
